import React, { useState } from 'react'
import { Container, Typography, Box, Grid, TextField, Button, Paper, Alert } from '@mui/material'
import EmailIcon from '@mui/icons-material/Email'
import PhoneIcon from '@mui/icons-material/Phone'
import LocationOnIcon from '@mui/icons-material/LocationOn'

export default function ContactPage() {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        message: ''
    })
    const [submitted, setSubmitted] = useState(false)

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault()
        // Here you would typically send the data to a backend
        console.log('Form submitted:', formData)
        setSubmitted(true)
        setFormData({ name: '', email: '', message: '' })
    }

    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        })
    }

    return (
        <Container maxWidth="lg" sx={{ py: 8 }}>
            <Box sx={{ textAlign: 'center', mb: 6 }}>
                <Typography variant="h3" component="h1" gutterBottom fontWeight="bold" color="primary">
                    Get in Touch
                </Typography>
                <Typography variant="h6" color="text.secondary" sx={{ maxWidth: 600, mx: 'auto' }}>
                    Have questions about our solar solutions? We're here to help!
                </Typography>
            </Box>

            <Grid container spacing={6}>
                {/* Contact Info */}
                <Grid item xs={12} md={5}>
                    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column', gap: 4 }}>
                        <Paper sx={{ p: 4, borderRadius: 2 }}>
                            <Box sx={{ display: 'flex', alignItems: 'flex-start', mb: 3 }}>
                                <EmailIcon fontSize="large" color="primary" sx={{ mr: 2 }} />
                                <Box>
                                    <Typography variant="h6" fontWeight="bold">Email Us</Typography>
                                    <Typography variant="body1" color="text.secondary">
                                        support@starwaveenergy.live
                                    </Typography>
                                </Box>
                            </Box>

                            <Box sx={{ display: 'flex', alignItems: 'flex-start', mb: 3 }}>
                                <PhoneIcon fontSize="large" color="primary" sx={{ mr: 2 }} />
                                <Box>
                                    <Typography variant="h6" fontWeight="bold">Call Us</Typography>
                                    <Typography variant="body1" color="text.secondary">
                                        0313 9766286
                                    </Typography>
                                </Box>
                            </Box>

                            <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
                                <LocationOnIcon fontSize="large" color="primary" sx={{ mr: 2 }} />
                                <Box>
                                    <Typography variant="h6" fontWeight="bold">Visit Us</Typography>
                                    <Typography variant="body1" color="text.secondary">
                                        Farah naz shopping complex,<br />
                                        opp Hafiz Plaza, Tangi Road,<br />
                                        Charsadda
                                    </Typography>
                                </Box>
                            </Box>
                        </Paper>

                        <Paper sx={{ p: 4, bgcolor: 'primary.main', color: 'white', borderRadius: 2 }}>
                            <Typography variant="h5" fontWeight="bold" gutterBottom>
                                Need a Custom Quote?
                            </Typography>
                            <Typography variant="body1" sx={{ opacity: 0.9 }}>
                                Our engineers can design a custom solar solution tailored to your energy needs. Contact us today for a free consultation.
                            </Typography>
                        </Paper>
                    </Box>
                </Grid>

                {/* Contact Form */}
                <Grid item xs={12} md={7}>
                    <Paper sx={{ p: 4, borderRadius: 2 }}>
                        <Typography variant="h5" fontWeight="bold" gutterBottom sx={{ mb: 3 }}>
                            Send us a Message
                        </Typography>

                        {submitted && (
                            <Alert severity="success" sx={{ mb: 3 }}>
                                Thank you for contacting us! We will get back to you shortly.
                            </Alert>
                        )}

                        <Box component="form" onSubmit={handleSubmit}>
                            <Grid container spacing={3}>
                                <Grid item xs={12}>
                                    <TextField
                                        fullWidth
                                        label="Full Name"
                                        name="name"
                                        value={formData.name}
                                        onChange={handleChange}
                                        required
                                        variant="outlined"
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        fullWidth
                                        label="Email Address"
                                        name="email"
                                        type="email"
                                        value={formData.email}
                                        onChange={handleChange}
                                        required
                                        variant="outlined"
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        fullWidth
                                        label="Message"
                                        name="message"
                                        multiline
                                        rows={6}
                                        value={formData.message}
                                        onChange={handleChange}
                                        required
                                        variant="outlined"
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <Button
                                        type="submit"
                                        variant="contained"
                                        size="large"
                                        fullWidth
                                        sx={{ py: 1.5, fontSize: '1.1rem' }}
                                    >
                                        Send Message
                                    </Button>
                                </Grid>
                            </Grid>
                        </Box>
                    </Paper>
                </Grid>
            </Grid>
        </Container>
    )
}
